import { IonLabel } from '@ionic/react';
import { useTranslation } from 'react-i18next';

import { Mission } from '@carers/views/Missions/models/Missions';
import { Request } from '@carers/views/Requests/models/Requests';
import Alert from '@shared/components/Alert/Alert';
import { CONTRACTS } from '@shared/constants/missionsConstants';

type InterimAlertProps = {
  mission: Request | Mission;
};

const InterimAlert = ({ mission }: InterimAlertProps) => {
  const { t } = useTranslation('app', {
    keyPrefix: 'carers.requests.detail.alerts.interimRequest',
  });

  const isInterimMission = mission.contract.value === CONTRACTS.INTERIM;

  if (!isInterimMission) {
    return null;
  }

  return (
    <Alert type="warning" title={t('title')}>
      <IonLabel>{t('message')}</IonLabel>
    </Alert>
  );
};

export default InterimAlert;
